<template>
  <div :key="key" class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <!-- <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加工作分类')">添加</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteGroup">批量删除</el-button> -->
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
    </div>
    <!-- 筛选 -->
    <el-form ref="screenForm" :inline="true" :model="screenForm" class="demo-form-inline">
      <el-form-item label="用户手机号：" prop="memberPhone">
        <el-input v-model="screenForm.phone" />
      </el-form-item>
      <el-form-item label="投递企业：" prop="companyName">
        <el-input v-model="screenForm.companyName" />
      </el-form-item>
      <el-button type="primary" size="mini" icon="el-icon-search" style="margin-right: 10px" @click="screenData">筛选</el-button>
    </el-form>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        :stripe="true"
        :border="true"
        size="mini"
        tooltip-effect="dark"
      >
        <el-table-column type="index" width="50" label="#" />
        <el-table-column prop="sendResumeRecordStatus" label="状态" />
        <el-table-column prop="memberPhone" label="用户" />
        <el-table-column prop="companyName" label="投递企业" />
        <el-table-column prop="jobName" label="投递职位" />
        <el-table-column label="企业账号">
          <template slot-scope="scope">
            <div style="width: max-content; height: 50px; display: flex; align-items: center; margin: 0 auto">
              <el-image
                :src="scope.row.avator"
                style="width: 50px; height: 50px; border-radius: 6px; margin-right: 10px"
                @click="previewImage(scope.row.avator)"
              />
              <div style="display: flex; flex-direction: column">
                <span>{{ scope.row.companyUsername }}</span>
                <span>{{ scope.row.conpanyAccountName }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="创建时间" />
        <el-table-column label="面试时间">
          <template slot-scope="scope">
            <span v-if="scope.row.interviewDate">{{ scope.row.interviewDate | momentFilter('YYYY-MM-DD HH:mm') }} </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import pagination from '@/mixins/pagination'
export default {
  mixins: [pagination],
  data() {
    return {
      key: 0,
      tableData: [],
      screenForm: {
        phone: '',
        companyName: ''
      },
      loading: true,
      tableH: 0
    }
  },

  created() {
    this.getTableList()
  },
  mounted() {
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    getTableList() {
      this.loading = true
      return this.$api.member
        .reqResumeList(this.page)
        .then((res) => {
          this.tableData = res.records
          this.total = res.total
          const ids = res.records
            .map((item) => item.memberId)
            .filter((id) => id)
            .join(',')
          const comIds = res.records
            .map((item) => item.companyId)
            .filter((id) => id)
            .join(',')
          const comAccIds = res.records
            .map((item) => item.companyAccountId)
            .filter((id) => id)
            .join(',')

          Promise.all([this.getMemberByIds({ ids }), this.getCompanyNameByIds({ ids: comIds }), this.getCompanyAccountByIds({ ids: comAccIds })])
            .then(() => {
              this.loading = false
              console.log('res', this.tableData)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    getMemberByIds(data) {
      return this.$api.member
        .reqMemberByIds(data)
        .then((res) => {
          try {
            this.tableData.forEach((item) => {
              this.$set(item, 'memberPhone', res[item.memberId] && res[item.memberId].phone)
            })
          } catch (error) {
            console.error(error)
          }
        })
        .catch(() => {})
    },
    getCompanyAccountByIds(data) {
      return this.$api.company
        .reqCompanyAccountByIds(data)
        .then((res) => {
          this.tableData.forEach((item) => {
            this.$set(item, 'avator', res[item.companyAccountId] && res[item.companyAccountId].avator)
            this.$set(item, 'companyUsername', res[item.companyAccountId] && res[item.companyAccountId].username)
            this.$set(item, 'conpanyAccountName', res[item.companyAccountId] && res[item.companyAccountId].name)
          })
        })
        .catch(() => {})
    },
    getCompanyNameByIds(data) {
      return this.$api.company
        .reqCompanyByIds(data)
        .then((res) => {
          this.tableData.forEach((item) => {
            this.$set(item, 'accountAvatar', res[item.companyId] && res[item.companyId].companyName)
          })
        })
        .catch(() => {})
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      this.$refs.screenForm.resetFields()
      Promise.all([this.getTableList()])
        .then((res) => {
          this.$message.success('刷新成功')
        })
        .catch(() => {
          this.$message.error('刷新成功')
        })
    },
    screenData() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Object.assign(this.page, this.screenForm)
      this.getTableList()
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 84px);

  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
